exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".kayenta-list a.clickable {\n  margin: 5px 0 0 10px;\n}\n.kayenta-list input.input-sm {\n  width: 93%;\n}\n", ""]);

